module.exports = __webpack_public_path__ + "img/icon-web-home-03.182df418.png";